// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3rOUm","rootCenter":"LoadMoreObserver_rootCenter__20UbZ","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__237b3"};